__turbopack_export_value__({
  "body-logo-18": "SuccessPopup-module-scss-module__hxQ6ba__body-logo-18",
  "body-text-12": "SuccessPopup-module-scss-module__hxQ6ba__body-text-12",
  "body-text-14": "SuccessPopup-module-scss-module__hxQ6ba__body-text-14",
  "body-text-16": "SuccessPopup-module-scss-module__hxQ6ba__body-text-16",
  "body-text-18": "SuccessPopup-module-scss-module__hxQ6ba__body-text-18",
  "body-text-20": "SuccessPopup-module-scss-module__hxQ6ba__body-text-20",
  "body-text-24": "SuccessPopup-module-scss-module__hxQ6ba__body-text-24",
  "body-text-24-2": "SuccessPopup-module-scss-module__hxQ6ba__body-text-24-2",
  "body-text-heading-2": "SuccessPopup-module-scss-module__hxQ6ba__body-text-heading-2",
  "body-text-heading-3": "SuccessPopup-module-scss-module__hxQ6ba__body-text-heading-3",
  "body-text-medium-14": "SuccessPopup-module-scss-module__hxQ6ba__body-text-medium-14",
  "body-text-medium-16": "SuccessPopup-module-scss-module__hxQ6ba__body-text-medium-16",
  "body-text-medium-18": "SuccessPopup-module-scss-module__hxQ6ba__body-text-medium-18",
  "body-text-medium2-18": "SuccessPopup-module-scss-module__hxQ6ba__body-text-medium2-18",
  "body-text2-14": "SuccessPopup-module-scss-module__hxQ6ba__body-text2-14",
  "body-text2-16": "SuccessPopup-module-scss-module__hxQ6ba__body-text2-16",
  "btnConfirm": "SuccessPopup-module-scss-module__hxQ6ba__btnConfirm",
  "button-primary-text": "SuccessPopup-module-scss-module__hxQ6ba__button-primary-text",
  "button-text": "SuccessPopup-module-scss-module__hxQ6ba__button-text",
  "button2-text": "SuccessPopup-module-scss-module__hxQ6ba__button2-text",
  "card-shadow": "SuccessPopup-module-scss-module__hxQ6ba__card-shadow",
  "effect-menu": "SuccessPopup-module-scss-module__hxQ6ba__effect-menu",
  "header-1": "SuccessPopup-module-scss-module__hxQ6ba__header-1",
  "main-container": "SuccessPopup-module-scss-module__hxQ6ba__main-container",
  "main-footer-container": "SuccessPopup-module-scss-module__hxQ6ba__main-footer-container",
  "main-header-container": "SuccessPopup-module-scss-module__hxQ6ba__main-header-container",
  "modal": "SuccessPopup-module-scss-module__hxQ6ba__modal",
  "notification": "SuccessPopup-module-scss-module__hxQ6ba__notification",
  "notificationTitle": "SuccessPopup-module-scss-module__hxQ6ba__notificationTitle",
  "txt-12-bold": "SuccessPopup-module-scss-module__hxQ6ba__txt-12-bold",
  "txt-14-bold": "SuccessPopup-module-scss-module__hxQ6ba__txt-14-bold",
  "txt-14-bold-caps": "SuccessPopup-module-scss-module__hxQ6ba__txt-14-bold-caps",
  "txt-14-med": "SuccessPopup-module-scss-module__hxQ6ba__txt-14-med",
  "txt-16-bold": "SuccessPopup-module-scss-module__hxQ6ba__txt-16-bold",
  "txt-16-med": "SuccessPopup-module-scss-module__hxQ6ba__txt-16-med",
  "txt-18-bold": "SuccessPopup-module-scss-module__hxQ6ba__txt-18-bold",
  "txt-18-medium": "SuccessPopup-module-scss-module__hxQ6ba__txt-18-medium",
  "txt-18-medium-24": "SuccessPopup-module-scss-module__hxQ6ba__txt-18-medium-24",
  "txt-24-semi": "SuccessPopup-module-scss-module__hxQ6ba__txt-24-semi",
});
